(ns app.account-settings.views
  (:require
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]
   [app.routes :as routes]
   [re-com.core :as re-com :refer [at h-box box  v-box modal-panel]]
   [app.styles :refer [app-bar new-workspace-container create-workspace-title create-workspace-space]]
   [app.events :as events]
   [app.new-workspace.events :as wevents]
   [app.new-workspace.subs :as wsubs]
   [app.subs :as subs]
   [reagent.core  :as reagent :refer [atom]]
   [app.components.buttons.views :as buttons]
   [app.components.headers.views :refer [header]]
   [app.account-settings.styles :refer [settings-card settings-panel]]
   [app.components.input-field.views :refer [input-field]]))


(defn template-header []
  [v-box
   :src (at)
   :gap "8px"
   :children [[header {:label "Account Settings" :type :title :size :large}]]])


(defn settings-card-view [item-input-id]
  (let [settings-clicked? (reagent/atom false)
        username @(re-posh/subscribe [::subs/user-name])
        display-name (:user/name username) 
        text-val (reagent/atom display-name)]
    (fn []
      [v-box
       :src (at)
       :gap "17px"
       :class (settings-card)
       :children [[header {:label "Display name" :type :large :size :semibold}]
                  (if @settings-clicked?
                    [input-field {:placeholder "" :disable false :value text-val
                                  :onChange #(do
                                               (reset! text-val %))
                                  :width "448px"}]
                    [header {:label "Change your display name" :type :large :size :regular}])
                  (if @settings-clicked? [h-box
                                          :gap "15px"
                                          :children [[buttons/button {:action :cta :type :secondary
                                                                      :title "cancel"
                                                                      :size :medium :onClick  #(do (reset! settings-clicked? false))}]
                                                     [buttons/button {:action :cta :type :primary
                                                                      :title "save"
                                                                      :size :medium :onClick  #(do
                                                                                                 (re-posh/dispatch [::wevents/update-account-display-name {:workspace-id item-input-id :display-name @text-val}])
                                                                                                 (re-posh/dispatch [::events/add-user-name @text-val])
                                                                                                 (reset! settings-clicked? false))}]]]
                      [box :width "189px" :child [buttons/button {:action :cta :type :primary
                                                                  :title "Change Display Name"
                                                                  :size :medium :onClick  #(do (reset! settings-clicked? true))}]])]])))

(defn icon-settings-card-view []
  [v-box
   :src (at)
   :gap "17px"
   :class (settings-card)
   :children [[header {:label "Account avatar" :type :large :size :semibold}]
              [header {:label "Change account avatar to make it easier for people to identify you." :type :large :size :regular}]
              [:div
               {:style {:position "relative"
                        :overflow "hidden"
                        :cursor "pointer"
                        :display "inline-block"}}
               [:input {:style {:font-size "100px"
                                :position "absolute"
                                :left 0
                                :top 0
                                :opacity 0}
                        :type "file"
                        :name "file"
                        :id "contained-button-file"
                        :accept "image/*"
                        :multipe true
                        :onChange (fn [^js/Event ev]
                                    (let [form-data (js/FormData.)]
                                      (.append form-data "file" (first (-> ev .-target.files)))
                                      (re-posh/dispatch [::wevents/upload-account-image {:workspace-id "b8d57063-148c-4280-b1fe-b9461a11a5fd" :file form-data}])))}]
               [:label {:htmlFor "contained-button-file"}
                [buttons/button {:action :cta :type :primary
                                 :title "Upload icon"
                                 :size :medium
                                 :attr {:htmlFor "contained-button-file"}}]]]]])

(defn dialog-markup
  [workspace-id item-input-id item-input-value cancel-dialog]
  (let [text-val (reagent/atom nil)]
    [  :src (at)
     :padding  "8px"
     :gap "16px"
     :justify :center
     :align :center
     :width "408px"
     :children [[header {:label "Deleting this workspace will also delete all the content within it.
                                 You will not be able to restore it afterwords." :type :small :size :semibold
                         :style {:text-align "center"}}]
                [header {:label "To confirm, please enter the workspace name" :type :small :size :semibold}]
                [input-field {:placeholder "" :disable false :value item-input-value
                              :onChange #(do (reset! text-val %) (re-posh/dispatch [::wevents/change-new-workspace item-input-id @text-val]))
                              :width "366px"}]
                [h-box :src (at)
                 :gap      "8px"
                 :children [[buttons/button {:action :cta :type :secondary
                                             :title "Keep Workspace"
                                             :size :large
                                             :onClick cancel-dialog}]
                            [buttons/button {:action :warning :type :primary
                                             :title "Delete Workspace"
                                             :size :large
                                             :onClick #(re-posh/dispatch [::wevents/delete-workspace workspace-id])}]]]]]))

(defn notifications-settings-card-view [workspace-id item-input-id item-input-value]
  (let [show-dialog? (reagent/atom false)
        cancel-dialog (fn [event]
                        (reset! show-dialog? false)
                        false)]
    (fn []
      [v-box
       :src (at)
       :gap "17px"
       :class (settings-card)
       :children [[header {:label "Email notifications" :type :large :size :semibold}]
                  [header {:label "Subscribed to all" :type :large :size :regular}]
                  [box :width "189px" :child [buttons/button {:action :cta :type :primary
                                                              :title "Update Settings"
                                                              :size :medium
                                                              :onClick   #(do (reset! show-dialog? true))
                                                              ;; #(re-posh/dispatch [::wevents/delete-workspace workspace-id])
                                                              }]]
                  (when @show-dialog? [modal-panel :src (at)
                                       :backdrop-color   "grey"
                                       :backdrop-opacity 0.4
                                       :child            [dialog-markup workspace-id item-input-id item-input-value cancel-dialog]])]])))
(defn account-settings-panel []
  (let [{item-input-id :selected-workspace/id
         item-input-value :selected-workspace/name} @(re-posh/subscribe [::subs/selected-workspace-data])]
    [v-box
     :src      (at)
     :height "100vh"
     :size "auto"
     :gap "22px"
     :class (settings-panel)
     :children [[template-header]
                [icon-settings-card-view]
                [settings-card-view  item-input-id]]]))

(defmethod routes/panels :account-settings-panel [] [account-settings-panel])